<template>
  <v-app>
    <notifications position="bottom center" classes="notification-style" width="400" height="700" animation-type="css" />

    <!-- <TabletSidebar v-if="$vuetify.breakpoint.width <= 980"></TabletSidebar> -->
    <sidebar></sidebar>

    <app-bar></app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
import sidebar from "@/components/core/Sidebar";
import AppBar from "@/components/core/AppBar";
// import TabletSidebar from "@/components/core/TabletSidebar";

export default {
  components: {
    sidebar: sidebar,
    "app-bar": AppBar,
    // TabletSidebar,
  },
};
</script>

<style >
.notification-style {
  font-size: 20px;
  padding: 20px;
  border-top: 5px solid #430000;
  border-top-color: #560700;
}

.v-application .error {
  background-color: #ff5252 !important;
  border-color: #000000 !important;
}


/* .vue-notification-template {
  padding: 20px;
} */
</style>
